import { useEffect, useState, } from 'react';
import { Link, useParams, useHistory, } from 'react-router-dom';
import htmlParser from 'react-html-parser';
import axios from 'axios';

import { globalSettings, isUndNullEmp, languageObjGet, responseGet, sendMessageCloseCurrentWindowAsync } from '../../helpers/settings';
import { contactMessageEmailBodyGet } from '../../controllers/emails/emails';
import { GlobalFormats } from '../../classes/main/globalFormats';
import Menu from '../main/Menu';
import CssfxLoading from '../main/CssfxLoading';

const currentMethod = 'ContactMessage';

export default function ContactMessage({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    const { id, } = useParams();
    const history = useHistory();
    const [contactMessage, setContactMessage] = useState({});
    const [htmlCode, setHtmlCode] = useState('');
    const [showContactMessage, setShowContactMessage] = useState(false);
    const [showLoading, setShowLoading] = useState(true);
    //#endregion variables

    //#region methods
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading(true);
            //#region get contact message data
            const result = await axios?.get(
                `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlContactMessages}/${id}/${languageObj?.id}`,
            );
            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: {},
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                history.push('/');
                return;
            }

            setContactMessage(response?.result);
            //#endregion get contact message data

            //#region get html message
            const contactMessage = response.result;
            response = contactMessageEmailBodyGet({
                id: contactMessage?.id,
                name: contactMessage?.name,
                email: contactMessage?.email,
                subject: contactMessage?.subject,
                message: contactMessage?.message,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading(false);
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: {},
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                history.push('/');
                return;
            }

            setHtmlCode(response?.result);
            setShowLoading(false);
            setShowContactMessage(true);
            //#endregion get html message
        } catch (ex) {
            setShowLoading(false);
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: {},
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            return;
        }
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'onLoad - form', });
    }, []); //eslint-disable-line react-hooks/exhaustive-deps

    //#endregion methods

    return (
        <div>
            <Menu viewName='home' process='home' />

            <div className='content-wrapper'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{globalSettings?.labels?.contact?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    {/* <li className='breadcrumb-item'><a href='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</a></li> */}
                                    <li className='breadcrumb-item'><Link to='/'>{globalSettings?.labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{globalSettings?.labels?.contact?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        {/* <div className='text-center'>
                            <h4 className='display-4'>
                                {globalSettings?.app?.name}
                            </h4>
                        </div> */}
                        {!showLoading ?
                            <>
                                {!isUndNullEmp({ data: contactMessage, subMethod: currentMethod, })?.result
                                    && showContactMessage ?
                                    <>
                                        {htmlParser(htmlCode)}
                                        {/* <img alt='appLogo' src={globalSettings?.images?.appLogo} style={styles?.appLogoHome} /> */}
                                    </>
                                    :
                                    <></>
                                }
                            </>
                            :
                            <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                width={40}
                                height={40}
                                color={globalSettings?.colors?.infoColorExp}
                                msgText={globalSettings?.messages?.processing?.[languageObj?.id]}
                                msgOrientation='text-center'
                                msgTextMuted={true} />
                        }

                        <br />

                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content */}

            </div>
        </div>
    );
}